import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import { ready } from '../shared/ready'
import { ScreenerPremium } from './screener-premium'
import { ScreenerTimeframeBar } from './screener-timeframe-bar'

const SCREENER_TIMEFRAME_REACT_ROOT_ID = 'screener-timeframe-container'

const screenerTimeframeReactMount = () => {
  const timeframeContainer = document.getElementById(SCREENER_TIMEFRAME_REACT_ROOT_ID)
  if (timeframeContainer) {
    ReactDOM.render(
      <BrowserRouter>
        <ScreenerTimeframeBar />
      </BrowserRouter>,
      timeframeContainer
    )
  }
}

const screenerTimeframeReactUnmount = () => {
  const timeframeContainer = document.getElementById(SCREENER_TIMEFRAME_REACT_ROOT_ID)
  if (timeframeContainer) ReactDOM.unmountComponentAtNode(timeframeContainer)
}

ready(() => {
  const screener = document.getElementById('screener-react')
  if (screener && FinvizSettings.hasUserPremium) {
    ReactDOM.render(<ScreenerPremium />, screener)
  }
  screenerTimeframeReactMount()
})

window.ScreenerTimeframeReactMount = screenerTimeframeReactMount
window.ScreenerTimeframeReactUnmount = screenerTimeframeReactUnmount
